import Cookie from "js-cookie";
import appConfig from "./appConfig";
import { PREVIEW_COOKIE_NAME, PREVIEW_COOKIE_VALUE } from "../../../common/constants/v2/Constants";

export function isUsingPreviewCookie(): boolean {
    return Cookie.get(PREVIEW_COOKIE_NAME) === PREVIEW_COOKIE_VALUE;
}

export function isOnboardingEnabled(): boolean {
    return appConfig().onboardingEnabled || isUsingPreviewCookie();
}
